const Loader = ({
  variant = "primary",
}: {
  variant?: "primary" | "secondary";
}) => {
  if (variant == "primary") {
    return (
      <div className="flex items-center justify-center h-[400px] w-full bg-gray-100">
        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  } else {
    return (
      <div className="flex items-center justify-center h-full bg-transparent">
        <div className="w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
};

export default Loader;
